// import { ordersApi } from '@/api';
import { SAMPLE_STATUSES_DESC } from '@/config/constants';

const samplesFilters = [
  {
    // Options come from GET /samples/categories (see SamplesIndex).
    // Sent as the `category` query parameter, not in the where clause.
    name: 'category',
    label: 'category',
    type: 'singleSelect',
  },
  {
    name: 'orderId',
    label: 'orderId',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'orderTitle',
    label: 'orderName',
    type: 'text',
    whereOperator: 'regexp',
    // type: 'autocomplete',
    // autocompleteSearch: async (queryString, cb) => {
    //   const ordersResponse = await ordersApi.findOrdersByTitle(queryString);
    //   const filteredResults = ordersResponse.data.map(item => (
    //     {
    //       label: item.title,
    //       value: item.id,
    //     }
    //   ));
    //   // call callback function to return suggestions
    //   cb(filteredResults);
    // },
    // whereOperator: '=',
  },
  {
    name: 'id',
    label: 'sampleId',
    type: 'number',
    whereOperator: '=',
  },
  {
    name: 'productCode',
    label: 'productCode',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'productName',
    label: 'productName',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'customerProductName',
    label: 'customerProductName',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'lot',
    label: 'lot',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'status',
    label: 'status',
    type: 'select',
    whereOperator: '=',
    options: Object.keys(SAMPLE_STATUSES_DESC)
      .map(key => ({ label: `enums.sampleStatuses.${SAMPLE_STATUSES_DESC[key]}`, value: key })),
  },
  {
    name: 'sampleReportCodes',
    label: 'sampleReportCodes',
    type: 'text',
    whereOperator: 'regexp',
  },
  // {
  //   name: 'date',
  //   label: 'date',
  //   type: 'dateRange',
  // },
];

export default samplesFilters;
